import { GermanAddress } from '@angular-material-extensions/google-maps-autocomplete';

export class FormData {
    Immobilie: string = '';
    Typ: string = '';
    Wohnflaeche: number;
    Grundstücksflaeche: number;
    Baujahr: number;
    Zimmeranzahl: number;
    Zustand: string = '';
    Postleitzahl: number;
    Stadt: string;
    Adresse: string;
    Adresszusatz: string;
    Wertschätzung: string;
    Anrede: string;
    Vorname: string;
    Nachname: string;
    Email: string;
    Telefonnummer: string;
    Geburtsjahr: string;
    Promotion: string;
    Placestring: GermanAddress;

    clear() {
        this.Immobilie = '';
        this.Typ = '';
        this.Wohnflaeche;
        this.Grundstücksflaeche;
        this.Zimmeranzahl;
        this.Baujahr;
        this.Zustand = '';
        this.Postleitzahl;
        this.Stadt = '';
        this.Adresse = '';
        this.Adresszusatz = '';
        this.Wertschätzung = '';
        this.Anrede = '';
        this.Vorname = '';
        this.Nachname = '';
        this.Email = '';
        this.Telefonnummer = '';
        this.Geburtsjahr = '';
        this.Promotion = '';
    }
}

export class Main {
    type: string = '';
}

export class Type {
    type: string = '';
}

export class Size {
    livingspace: number;
    space: number;
    room: number;
}

export class Step3 {
    constructionyear: number;
    constructioncondition: string;
}

export class Step4 {
    postalcode: number;
    city: string;
    address: string;
    address2: string;
    price: string;
    placestring: GermanAddress;
}

export class Step5 {
    gender: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    birthyear: string;
    source: string;
}